import style from "./style.scss";
import { mergeClasses } from "../../helpers";

const Down = ({ open = false }) => (
  <span class={mergeClasses([style.down, open ? style.open : null])}>
    <span class={style.wrapper}>
      <span class={style.line} />
      <span class={style.line} />
    </span>
  </span>
);

export default Down;
